import { APP_INITIALIZER, ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TrackingModuleConfig } from '../model/tracking.model';
import { TRACKING_CONFIG, TrackingService } from './tracking.service';
import { trackingInitializer } from './tracking.initializer';

@NgModule({
  declarations: [],
  imports: [RouterModule],
})
export class TrackingModule {
  static forRoot(config?: TrackingModuleConfig): ModuleWithProviders<TrackingModule> {
    if (!config) {
      config = {
        debug: false,
      };
    }

    return {
      ngModule: TrackingModule,
      providers: [
        TrackingService,
        { provide: TRACKING_CONFIG, useValue: config },
        {
          provide: APP_INITIALIZER,
          useFactory: () => trackingInitializer(),
          multi: true,
        },
      ],
    };
  }
}
